import { Popover, PopoverBody, PopoverContent, PopoverTrigger } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { IKeyFiguresData } from "src/api/server/extended-search";
import { ISearch } from "src/components/pages/search/search.types";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { PopoverButton } from "../popover-button";
import { KeyFiguresFilterBodyContent } from "./key-figures-filter-body-content";

const KEY_FIGURES_POPOVER_BODY_TEST_ID = "key-figures-popover-body";

interface IKeyFiguresPopover extends ISearch {
    keyFiguresData: IKeyFiguresData;
}

export const KeyFiguresPopover = ({ keyFiguresData, onSearch }: IKeyFiguresPopover) => {
    const { t } = useTranslation("extended-search");

    const { keyFigures: selectedKeyFigures } = useSearchStore();
    const totalNumberOfKeyFigures = keyFiguresData.keyFiguresGroups.reduce((acc, keyFiguresGroup) => acc + keyFiguresGroup.keyFigures.length, 0);

    return (
        <Popover placement="bottom" flip={false}>
            {({ isOpen }) => (
                <>
                    <PopoverTrigger>
                        <PopoverButton
                            flex={1}
                            isOpen={isOpen}
                            title={t("key-figures")}
                            badgeInfo={`${selectedKeyFigures.length} / ${totalNumberOfKeyFigures}`}
                        />
                    </PopoverTrigger>
                    <PopoverContent
                        rootProps={{ w: ["unset", "100%", "unset"], px: ["unset", 1, "unset"] }}
                        w={["100%", "100%", "810px"]}
                        overflow="hidden"
                    >
                        <PopoverBody p="0" data-test-id={KEY_FIGURES_POPOVER_BODY_TEST_ID}>
                            <KeyFiguresFilterBodyContent keyFiguresData={keyFiguresData} onSearch={onSearch} />
                        </PopoverBody>
                    </PopoverContent>
                </>
            )}
        </Popover>
    );
};
